// Shared base path for all BYOD API endpoints
export const BYOD_API_BASE = 'analytics/byod';

// ── Queries ───────────────────────────────────────────────────────────────────
export {useDashboardList} from './queries/useDashboardList';
export {useLandingDashboard} from './queries/useLandingDashboard';
export {useReportList} from './queries/useReportList';
export {useLoadDashboard} from './queries/useLoadDashboard';
export {useWidgetCatalog} from './queries/useWidgetCatalog';
export {useWidgetDetail} from './queries/useWidgetDetail';
export type {WidgetDetail} from './queries/useWidgetDetail';
export {useFilterOptions} from './queries/useFilterOptions';
export {useFilterDefinitions} from './queries/useFilterDefinitions';
export {
  useTileData,
  ByodDragOverlayProvider,
  BYOD_TILE_QUERY_KEY,
} from './queries/useTileData';
export type {UseTileDataResult} from './queries/useTileData';

// ── Mutations ─────────────────────────────────────────────────────────────────
export {useSaveAndPublish} from './mutations/useSaveAndPublish';
export type {SaveAndPublishResponse} from './mutations/useSaveAndPublish';
export {useDeleteDashboard} from './mutations/useDeleteDashboard';

// ── Scheduling (widget + placement) ─────────────────────────────────────────────
export {
  useByodWidgetSchedule,
  useByodPlacementSchedule,
} from './schedule/useByodSchedule';
export type {UseByodScheduleResult} from './schedule/useByodSchedule';
